import { Problem } from '@yandex-int/k-common/typings';
import b from 'b_';
import cx from 'classnames';
import { BackgroundImage } from 'platform-components';
import { getProblemPreviewBg, getResourceImageWidth } from 'platform-components/utils';
import React, { ReactNode, useRef } from 'react';

import { ProblemWrapperContext } from 'common.components/problem-wrapper/context';

import './problem-wrapper.scss';

interface Props {
    mix?: string;
    children: ReactNode | ReactNode[];
    problem: Problem;
}

export const ProblemWrapper = ({ problem, children, mix }: Props) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const { bgColor, bgCover } = getProblemPreviewBg(problem);

    const contentAlignment = problem.content_alignment;
    const backgroundAlignment = problem.background_alignment;
    const illustration = problem.background_illustration_full_info;
    const imageWidth = illustration ? getResourceImageWidth(illustration) : undefined;

    return (
        <div
            className={cx(
                b('problem-wrapper', {
                    alignment: contentAlignment,
                    'with-alignment': Boolean(contentAlignment),
                }),
                mix
            )}
            ref={wrapperRef}
            style={{ backgroundColor: bgColor }}
        >
            <div className={b('problem-wrapper', 'background-set')}>
                <BackgroundImage
                    mix={b('problem-wrapper', 'background', {
                        'background-alignment': backgroundAlignment,
                    })}
                    objectFit="cover"
                    objectPosition="top left"
                    src={bgCover}
                />
                {illustration && (
                    <BackgroundImage
                        meta={{
                            strategy: 'imageSize',
                            baseWidth: imageWidth,
                        }}
                        mix="problem-wrapper__illustration"
                        objectFit={'cover'}
                        sizes={imageWidth ? `${imageWidth}px` : undefined}
                        src={illustration.file}
                    />
                )}
            </div>
            <ProblemWrapperContext.Provider value={{ wrapperRef }}>{children}</ProblemWrapperContext.Provider>
        </div>
    );
};
